export const MAX_FILE_SIZE_MB = 10; // Максимальный размер файла в МБ
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // Максимальный размер файла в байтах

export const SUPPORTED_FILE_FORMATS = {
  DEFAULT_EXTENSIONS: '.jpg, .jpeg, .docx, .rtf, .pdf, .xls, .xlsx, .png, .gif',
  DEFAULT_MIME_TYPES:
    'image/jpeg, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/rtf, application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, image/png, image/gif',
  IMAGE_EXTENSIONS: '.jpg, .jpeg, .png, .gif',
  IMAGE_MIME_TYPES: 'image/jpeg, image/png, image/gif',
  VIDEO_EXTENSIONS: '.mp4, .mov, .avi, .mkv',
  VIDEO_MIME_TYPES:
    'video/mp4, video/quicktime, video/x-msvideo, video/x-matroska',
};
